export default "__VITE_ASSET__Bdd5iKMb__"